import script from "./DetalleActividades.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleActividades.vue?vue&type=script&setup=true&lang=js"

import "./DetalleActividades.vue?vue&type=style&index=0&id=4efd76b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4efd76b2"]])

export default __exports__